export const GROUP_TYPES = {
  GROUP: 'group_widget',
} as const;
